import {ProductThumb} from '../../../../Components/Product/ProductThumb';
import React, {useEffect, useState} from 'react';
import InputCustom from '../../../../Components/InputCustom';
import SpinnerWheel from '../../../../Components/SpinnerWheel';
import Listbox from '../../../../Components/Listbox';
import ListboxItem from '../../../../Components/ListboxItem';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';


export const CategorySearchProduct = (
	{
		needTenantForSearch,
		searchProductFeed,
		handleSelectCategory,
		tenanSelected,
		categoryTypeSelected
	}
) => {

	const [inputSearch, setinputSearch] = useState('');
	const [list, setList] = useState([]);
	const [datas, setDatas] = useState([]);
	const [hasSearch, setHasSearch] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	function sortArrayProducts(a, b) {
		if (a.id < b.id) return -1;
		if (a.id > b.id) return 1;
		return 0;
	}
	function handleChangeSearch (el){
		setinputSearch(el);
	}

	const getListOfSpecificities = () => {
		if (!needTenantForSearch) {

			searchProductFeed.postSearchEmptyTenant(
				{
					'searchTerm': inputSearch,
					'requestedFields': ['NameAndThumbnail', 'Categories'],
					limit: 40,
				},
				(data:any) => {
					setIsLoading(false);
					// @ts-ignore
					setDatas([...data.products.sort(sortArrayProducts)]);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
				}
			);
		} else {
			searchProductFeed.postSearchWithTenant(
				{
					'searchTerm': inputSearch,
					'requestedFields': ['NameAndThumbnail', 'Categories'],
					limit: 40,
				},
				tenanSelected,
				(data:any) => {
					// @ts-ignore
					setDatas([...data.products.sort(sortArrayProducts)]);
					setIsLoading(false);
				},
				(error) => {
					console.log('=>(SearchProduct.tsx:77) error', error);
					setIsLoading(false);
				}
			);
		}
	};

	const filterCategories = (cat) => {
		return cat.filter((c) => c._type === categoryTypeSelected.name);
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			if (inputSearch && inputSearch.length !== 0) {
				setIsLoading(true);
				getListOfSpecificities();
			}
			setHasSearch(inputSearch.length > 0);
		}, 800);
		return () => {
			setList([]);
			setHasSearch(false);
			setIsLoading(false);
			clearTimeout(timer);
		};
	}, [inputSearch]);

	useEffect(() => {
		const formattedList:any = datas.map((product:any) => (
			<ListItem
				key={product.id}
				id={product.id}
				imageUrl={product.urlThumbnail}
				label={product.name}
				cat={filterCategories(product.categories)}
			/>
		));
		setList(formattedList);
	}, [datas]);

	function onAutoSelect(val:any) {
		handleSelectCategory(val[0]._name);
	}

	function ListItem({
		id,
		label,
		imageUrl,
		cat
	}) {
		return (
			<ListboxItem onClick={() => onAutoSelect(cat)}>
				<div className='flex'>
					<div className='flex_item_fix'>
						<ProductThumb
							url={imageUrl}
							width={40}
						/>
					</div>
					<div className='flex_item_full'>
						<div>{label}</div>
						<div className='s_13 grey_3 mt_3'>{id}</div>

						{cat.map((rayon) => (
							<div key={rayon._key} className='s_13 mt_3'>
								<span className='text_flag_light'>
									<span className='fw_medium'>{rayon._type}</span>
									&nbsp;{rayon._name}
								</span>
							</div>
						))}
					</div>
				</div>
			</ListboxItem>
		);
	}

	return (
		<>
			<div className='listbox_input_section flex_item_fix'>
				<InputCustom
					value={inputSearch}
					placeholder={'Search for a product'}
					autoFocus={true}
					fullWidth={true}
					forceFocus={true}
					onChange={(e) => handleChangeSearch(e.target.value)}
					clearable={true}
				/>
			</div>
			<div className='flex_item_auto vscroll_custom'>
				{isLoading &&
					<SpinnerWheel display='block' verticalSize="s" />
				}
				{!hasSearch &&
					<EmptyState
						icon={'fas fa-shopping-bag'}
						text={'Please start typing a product name or ID'}
						textSize="s"
					/>
				}
				{hasSearch &&
					<Listbox>
						{list}
					</Listbox>
				}
			</div>
		</>
	);
};
